import React from "react";
import { FaMapMarkerAlt, FaShoppingCart, FaStar } from "react-icons/fa";

import styles from "../../styles/pages/product/ProductDetailsPage.module.css";
import { openTrackedOutboundUrl } from "../../utils/trackOutboundClick";
import { readHomeChatMatchSessionId } from "../../utils/homeChatMatchPersistence";

const ProductNearbyStores = ({ stores, productPrice, productId }) => {
  if (!stores?.length) return null;

  return (
    <div className={styles.nearbyStoresSection}>
      <h3 className={styles.storesTitle}>
        <FaMapMarkerAlt /> Nearby Stores
      </h3>
      <div className={styles.storesList}>
        {stores.map((store, idx) => {
          const addressString =
            typeof store.address === "string"
              ? store.address
              : store.address
                ? `${store.address.street}, ${store.address.city}, ${store.address.state} ${store.address.zip}`
                : "Address not available";

          const fullAddress =
            typeof store.address === "string"
              ? store.address
              : store.address
                ? `${store.address.street}, ${store.address.city}, ${store.address.state}`
                : store.name;

          const buyLink = store.affiliateLink || store.website;
          const linkType = store.affiliateLink ? "affiliate" : "store";

          return (
            <div key={store._id || idx} className={styles.storeItem}>
              <div className={styles.storeInfo}>
                <h4 className={styles.storeName}>{store.name}</h4>
                <p className={styles.storeAddress}>{addressString}</p>
                {store.phone && <p className={styles.storePhone}>{store.phone}</p>}
                {store.distance && (
                  <p className={styles.storeDistance}>
                    {store.distance.toFixed(1)} km away
                  </p>
                )}
                {store.price ? (
                  <p className={styles.storePrice}>
                    ${store.price.toLocaleString("en-US")}
                    {productPrice && store.price < productPrice && (
                      <span className={styles.priceSavings}>
                        {" "}
                        (Save ${(productPrice - store.price).toLocaleString("en-US")})
                      </span>
                    )}
                  </p>
                ) : (
                  <p className={styles.storePrice}>Price not available</p>
                )}
                {store.stock !== undefined && (
                  <p className={styles.storeStock}>
                    {store.stock > 0
                      ? `In Stock (${store.stock} available)`
                      : "Out of Stock"}
                  </p>
                )}
                {store.rating > 0 && (
                  <p className={styles.storeRating}>
                    <FaStar /> {store.rating.toFixed(1)} ({store.reviewCount} reviews)
                  </p>
                )}
              </div>
              <div className={styles.storeActions}>
                <button
                  className={styles.buyNowStoreBtn}
                  onClick={() => {
                    window.open(
                      `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                        `${store.name} ${fullAddress}`,
                      )}`,
                      "_blank",
                    );
                  }}
                  type="button"
                >
                  <FaMapMarkerAlt /> Get Directions
                </button>
                {buyLink ? (
                  <button
                    className={styles.buyNowStoreBtn}
                    onClick={() => {
                      openTrackedOutboundUrl({
                        url: buyLink,
                        productId,
                        source: "nearby_store",
                        linkType,
                        sessionId: readHomeChatMatchSessionId() || undefined,
                        metadata: { storeId: store._id, storeName: store.name },
                      });
                    }}
                    type="button"
                  >
                    <FaShoppingCart /> Buy Now
                  </button>
                ) : (
                  <button
                    className={styles.buyNowStoreBtn}
                    disabled={!store.available}
                    type="button"
                  >
                    <FaShoppingCart /> {store.available ? "Buy Now" : "Not Available"}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductNearbyStores;
